<template>
  <v-container mx-0 px-0>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <div class="headline my-1">Edit profile</div>
      </v-flex>
      <v-flex xs12>
        <form v-on:keyup.enter="updateMe">
          <v-layout column>
            <v-flex xs12 text-xs-center ma-5 v-if="!me">
              <v-progress-circular
                indeterminate
                color="secondary"
              ></v-progress-circular>
            </v-flex>
            <v-flex v-if="me">
              <v-layout row wrap justify-center>
                <v-flex xs12 my-3 v-if="profileError">
                  <v-alert
                    :value="profileError"
                    type="error"
                    outline
                  >
                    {{ profileError }}
                  </v-alert>
                </v-flex>
                <v-flex xs12 my-3 v-if="profileUpdated && !meNeedsUpdate">
                  <v-alert
                    :value="profileUpdated"
                    type="success"
                    outline
                  >
                    Your profile was updated.
                  </v-alert>
                </v-flex>
                <v-flex xs12 my-3>
                  <v-text-field
                    label="Username"
                    v-model="me.username"
                    outline
                    hide-details
                    color="secondary"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 my-3 :class="{'pr-3': $vuetify.breakpoint.smAndUp}">
                  <v-text-field
                    label="First Name"
                    v-model="me.firstname"
                    outline
                    hide-details
                    color="secondary"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 my-3>
                  <v-text-field
                    label="Last Name"
                    v-model="me.lastname"
                    outline
                    hide-details
                    color="secondary"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 pt-2 text-xs-center text-sm-right>
                  <v-btn
                    middle
                    :disabled="!meNeedsUpdate"
                    color="secondary"
                    v-on:click="updateMe"
                    style="text-transform: unset; border-radius: 12px;"
                  >
                    Save
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
    <v-divider class="mt-5 mb-3"></v-divider>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <div class="headline my-1">Change password</div>
      </v-flex>
      <v-flex xs12>
        <form v-on:keyup.enter="updatePassword">
          <v-layout column>
            <v-flex v-if="me">
              <v-layout row wrap justify-center>
                <v-flex xs12 my-3 v-if="passwordError">
                  <v-alert
                    :value="passwordError"
                    type="error"
                    outline
                  >
                    {{ passwordError }}
                  </v-alert>
                </v-flex>
                <v-flex xs12 my-3 v-if="passwordUpdated && !passwordError">
                  <v-alert
                    :value="passwordUpdated"
                    type="success"
                    outline
                  >
                    Your password was changed.
                  </v-alert>
                </v-flex>
                <v-flex xs12 my-3>
                  <v-text-field
                    label="Current password"
                    v-model="currentPassword"
                    outline
                    hide-details
                    type="password"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 my-3 :class="{'pr-3': $vuetify.breakpoint.smAndUp}">
                  <v-text-field
                    label="New password"
                    v-model="password"
                    outline
                    hide-details
                    type="password"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 my-3>
                  <v-text-field
                    label="Confirm new password"
                    v-model="passwordConfirmation"
                    outline
                    :error-messages='pwdMatchError()'
                    type="password"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 pt-2 text-xs-center text-sm-right>
                  <v-btn
                    middle
                    :disabled="!newPassword"
                    color="secondary"
                    v-on:click="updatePassword"
                    style="text-transform: unset; border-radius: 12px;"
                  >
                    Save
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TeacherService from '@/services/TeacherService'

export default {
  components: {
  },
  data: function () {
    return {
      me: null,
      previousMe: null,
      profileError: null,
      profileUpdated: null,
      passwordError: null,
      currentPassword: null,
      password: null,
      passwordConfirmation: null,
      passwordUpdated: null
    }
  },
  mounted: async function () {
    try {
      const result = await TeacherService.get(this.$store.getters.user.id);

      this.me = result.data;
      this.previousMe = {
        username: result.data.username,
        firstname: result.data.firstname,
        lastname: result.data.lastname,
      }
    } catch (err) {
      console.log(err.response.data.error);
    }
    
  },
  computed: {
    meNeedsUpdate: function() {
      if (this.previousMe.username !== this.me.username || this.previousMe.firstname !== this.me.firstname || this.previousMe.lastname !== this.me.lastname) {
        return true;
      }

      return false;
    },
    newPassword: function () {
      if (this.password === this.passwordConfirmation) {
        return this.password;
      }

      return null;
    }
  },
  methods: {
    updateMe: async function () {
      try {
        const result = await TeacherService.put(this.$store.getters.user.id, {
          username: this.me.username,
          firstname: this.me.firstname,
          lastname: this.me.lastname
        });

        this.me = result.data;
        this.previousMe = {
          username: result.data.username,
          firstname: result.data.firstname,
          lastname: result.data.lastname
        }
        this.profileError = null;
        this.profileUpdated = true;
      } catch (err) {
        this.profileError = err.response.data.error;
      }
    },
    updatePassword: async function () {
      if (this.newPassword !== this.passwordConfirmation) {
        this.passwordError = 'Please enter your new password twice to continue.';
        return;
      }
      try {
        const result = await TeacherService.updatePassword(
          this.$store.getters.user.id,
          {
            currentPassword: this.currentPassword,
            newPassword: this.newPassword
          });

        
        this.passwordError = null;
        this.passwordUpdated = true;
      } catch (err) {
        this.passwordError = err.response.data.error;
      }
    },
    pwdMatchError () { 
      return (this.password === this.passwordConfirmation) ? '' : 'Please enter new password again.'
    }
  }
}
</script>

<style scoped>

</style>
